import api from "@/lib/api";

export const fileUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/worship/files/${path}`;

export function bibleSlides(p) {
  const slides = [];
  let cur = [];
  const flush = () => {
    if (!cur.length) return;
    const a = cur[0], z = cur[cur.length - 1];
    const book = p.reference.replace(/\s\d.*$/, "");
    slides.push({ kind: "bible", label: `${book} ${a.c}:${a.v}${z !== a ? `–${z.c !== a.c ? `${z.c}:` : ""}${z.v}` : ""}`, text: cur.map((x) => `${x.v} ${x.text}`).join(" ") });
    cur = [];
  };
  p.verses.forEach((x) => {
    const len = cur.reduce((n, y) => n + y.text.length, 0);
    if (cur.length && (cur.length >= 3 || len + x.text.length > 330)) flush();
    cur.push(x);
  });
  flush();
  return slides;
}

export const songSlides = (s) => (s.verses?.length
  ? s.verses.map((v, i) => ({ kind: v.kind, label: v.kind === "chorus" ? "Chorus" : String(s.verses.slice(0, i + 1).filter((x) => x.kind !== "chorus").length), text: v.text }))
  : (s.pages || []).map((p, i) => ({ kind: "image", label: `Page ${i + 1}`, src: fileUrl(p), text: "" })));

export async function presentable(item) {
  if (item.type === "bible") {
    const r = await api.get("/worship/bible/passage", { params: { ref: item.ref } });
    return { title: r.data.reference, label: `${r.data.reference} · WEB`, slides: bibleSlides(r.data), desc: { type: "bible", ref: r.data.reference, label: r.data.reference } };
  }
  if (item.type === "announcement") {
    const r = await api.get(`/worship/announcements/${item.item_id}`);
    return annPresentable([r.data]);
  }
  if (item.type === "song") {
    const r = await api.get(`/worship/songs/${item.item_id}`);
    return { title: r.data.title, label: "Special number", slides: songSlides(r.data), desc: { type: "song", item_id: r.data.id, label: r.data.title } };
  }
  return { title: "Blank screen", label: "", slides: [], blank: true, desc: { type: "blank", label: "Blank screen" } };
}

export const annPresentable = (list, rotate = 0) => ({
  title: list.length > 1 ? `Announcements (${list.length})` : list[0].title, label: "Announcement", rotate,
  slides: list.map((a) => ({ kind: "announcement", label: a.category, ann: a, text: a.title })),
  desc: list.length === 1 ? { type: "announcement", item_id: list[0].id, label: list[0].title } : null,
});
